/**
 * View title/description block.
 * @module volto-slate/blocks/Title/TitleBlockView
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SimpleTemplate from './SimpleTemplate';
import PresentationTemplate from './PresentationTemplate';

/**
 * View title block component.
 * @class View
 * @extends Component
 */
const TitleBlockView = (props) => {
  const { data } = props;
  return data?.variations === 'presentation' ? (
    <PresentationTemplate {...props} />
  ) : (
    <SimpleTemplate {...props} />
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
TitleBlockView.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default TitleBlockView;
